// ExcludedDonor.js
import React, { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import Autocomplete from '../Autocomplete';

const ExcludedDonor = ({ setFieldValue, selectedDonorIds, excludedDonorIds, setExcludedDonorIds, donorType = 'excluded', activeField, setActiveField}) => {

    const { values } = useFormikContext();
    const [sponsorErrors, setSponsorErrors] = useState({});
    const [disableInput, setDisableInput] = useState(false);

    const handleSubmit = async () => { 

        const donorValue = values[`${donorType}_donor`];
        setSponsorErrors((prevErrors) => ({
            ...prevErrors,
            [`${donorType}_donor`]: !donorValue || typeof donorValue == 'undefined' ? 'Please select donor Id' : '',
        }));


        if (donorValue && disableInput) {
            setFieldValue(`${donorType}_donor`, '');
        }

        if (donorValue && disableInput && !excludedDonorIds.includes(donorValue)) {
            
            setExcludedDonorIds((prevSelectedDonorIds) => {
                const updatedDonors = [...prevSelectedDonorIds, donorValue];
                setFieldValue('exclude_donors', updatedDonors);
                return updatedDonors;
            });
        }    
        
        setDisableInput(false);
    };    

    const handleRemoveDonor = (donorValue) => {
        setExcludedDonorIds((prevSelectedDonorIds) => prevSelectedDonorIds.filter((id) => id !== donorValue));
        setFieldValue('exclude_donors', values.exclude_donors.filter(donor => donor !== donorValue));
    };

    useEffect(() => {   
        console.log("sponsorErrors", sponsorErrors);      
    }, [sponsorErrors]); 

    return (
    <>      
      <div className="row">
        <div className="col-xl-6">
            <Autocomplete
                name="excluded_donor"
                label='Enter Donor ID you would like to exclude'
                placeholder="Type Here to Search..."
                error={sponsorErrors[`${donorType}_donor`]}   
                value={values[`${donorType}_donor`]}                                              
                setFieldValue={setFieldValue}
                allowInputChange={false}
                disableInputChange={disableInput}
                setDisableInputChange={setDisableInput}
                selectedDonorIds={selectedDonorIds}
                excludedDonorIds={excludedDonorIds}
                activeField={activeField}
                setActiveField={setActiveField}

                is_partof_parent_study={values.is_partof_parent_study}
                exclude_parent_study_donors={values.exclude_parent_study_donors}
                parent_study_id={values.parent_study_id}
            /> 
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-xl-6">
          <button className="el-main-button " type="button" onClick={handleSubmit}>
            <i className="jj-btn-primary-ico"></i> <span>Excluded Donors</span>
          </button> 
        </div>        
      </div>

      <div className="row  mt-3">
        <div className='col-xl-6'>        
            {excludedDonorIds.map((donorId, index) => (
                <>
                <div className="row mb-2">
                    <div className="col-xl-6" key={index}>
                        <div className='my-2'>
                        <strong>Donor ID:</strong> {donorId} </div>
                    </div>
                    <div className="col-xl-6 text-end" key={index}>
                        <i className="el-icon-trash text-danger"  onClick={() => handleRemoveDonor(donorId)}  style={{ cursor: "pointer" }}></i>
                    </div>                  
                </div>
                </>
            ))}
        </div>
      </div> 
    </>
  );
};

export default ExcludedDonor;